import type { Theme as ThemeBase } from '@mui/material';
// eslint-disable-next-line no-restricted-imports -- FIXME: This rule was recently enabled for the repo
import { useTheme as useThemeBase } from '@mui/material';

import type { Neutral } from '@savvy/deprecated-shared/theme';

// Declare our own theme properties
export type Theme = Omit<ThemeBase, 'palette'> & {
  palette: ThemeBase['palette'] & {
    background: {
      contrast: string;
    };
    neutral: Neutral;
    text: {
      charcoal: string;
      primary: string;
      secondary: string;
    };
    info: {
      alertBackground: string;
      alertContent: string;
    };
  };
};

export function useTheme(): Theme {
  const theme = useThemeBase<Theme>();
  return theme;
}
